var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.75C13.6193 8.75 12.5 7.63071 12.5 6.25C12.5 4.86929 13.6193 3.75 15 3.75C16.3808 3.75 17.5 4.86929 17.5 6.25C17.5 7.63071 16.3807 8.75 15 8.75Z",
    fill: "#092540"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17.5C13.6193 17.5 12.5 16.3808 12.5 15C12.5 13.6192 13.6193 12.5 15 12.5C16.3808 12.5 17.5 13.6193 17.5 15C17.5 16.3808 16.3807 17.5 15 17.5Z",
    fill: "#092540"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26.25C13.6193 26.25 12.5 25.1308 12.5 23.75C12.5 22.3692 13.6193 21.25 15 21.25C16.3808 21.25 17.5 22.3693 17.5 23.75C17.5 25.1308 16.3807 26.25 15 26.25Z",
    fill: "#092540"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsMenuIcon);
export default __webpack_public_path__ + "static/media/dots-menu-icon.f7b61f2415ebeb09169112efc98c4fba.svg";
export { ForwardRef as ReactComponent };